export default __webpack_public_path__ + "static/media/heart_blue.8ec545fa.svg";